import { render, staticRenderFns } from "./index.vue?vue&type=template&id=544839fa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544839fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('544839fa')) {
      api.createRecord('544839fa', component.options)
    } else {
      api.reload('544839fa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=544839fa&scoped=true", function () {
      api.rerender('544839fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/module/9-1-goods/index.vue"
export default component.exports